// extracted by mini-css-extract-plugin
module.exports = {"containing":"infohistory_containing__1IQzR"};